export default __webpack_public_path__ + "static/furgonetas-0f045c43eff6df87e4fb45a5a5253c37.png";